module.exports = __webpack_public_path__ + "img/a12.05c2a936.svg";